import React, { Component } from 'react';
import { Tabs, Tab, Card, ProgressBar, Row, Col, Container, Modal, } from "react-bootstrap";


const data = [
    {
        subject: "Mathematics",
        chapters: [
            { chapterId: 1, chapterName: "Algebra", performanceCount: 78 },
            { chapterId: 2, chapterName: "Calculus", performanceCount: 85 },
            { chapterId: 3, chapterName: "Coordinate Geometry", performanceCount: 72 },
            { chapterId: 4, chapterName: "Trigonometry", performanceCount: 68 }
        ]
    },
    {
        subject: "Physics",
        chapters: [
            { chapterId: 5, chapterName: "Mechanics", performanceCount: 80 },
            { chapterId: 6, chapterName: "Thermodynamics", performanceCount: 74 },
            { chapterId: 7, chapterName: "Optics", performanceCount: 69 },
            { chapterId: 8, chapterName: "Electrodynamics", performanceCount: 88 }
        ]
    },
    {
        subject: "Chemistry",
        chapters: [
            { chapterId: 9, chapterName: "Organic Chemistry", performanceCount: 82 },
            { chapterId: 10, chapterName: "Inorganic Chemistry", performanceCount: 70 },
            { chapterId: 11, chapterName: "Physical Chemistry", performanceCount: 76 },
            { chapterId: 12, chapterName: "Chemical Bonding", performanceCount: 84 }
        ]
    }
];

class ChapterAnalysis extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <Modal {...this.props} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">View Analysis</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{
                    width: '100%',
                    height: '500px',
                    overflow: 'auto',
                }}>
                    <Container className="mt-3">
                        <Tabs defaultActiveKey={data[0].subject} id="subject-tabs" className="mb-3">

                            {data.map((subjectItem) => (
                                <Tab eventKey={subjectItem.subject} title={subjectItem.subject} key={subjectItem.subject}>

                                    <Row>
                                        {subjectItem.chapters.map((chapter) => (
                                            <Col sm={6} key={chapter.chapterId} className="mb-3">

                                                <Card className="shadow-sm h-100">
                                                    <Card.Body>
                                                        <Card.Title>{chapter.chapterName}</Card.Title>

                                                        <ProgressBar
                                                            now={chapter.performanceCount}
                                                            label={`${chapter.performanceCount}%`}
                                                            striped variant={chapter.performanceCount > 50 ? "success" : "danger"}
                                                        />

                                                    </Card.Body>
                                                </Card>

                                            </Col>
                                        ))}
                                    </Row>

                                </Tab>
                            ))}

                        </Tabs>
                    </Container>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ChapterAnalysis;
